import { hideDialog, refresher, toastError } from "../../redux/guest-slices/other.slice"
import { DISABLE_USER_STATUS } from "../../utils/keywords"
import { useDispatch, useSelector } from "react-redux"
import UserServices from "../../services/user.service"
import { btnText, messages, titles } from "./data"
import InputFieldA from "../ui/InputFieldA"
import Icons from "../../assets/js/Icons"
import { useRef } from "react"

import {
  Box, Button, CircularProgress, DialogActions, DialogContent,
  DialogTitle, Icon, IconButton, Paper, Stack, Typography,
} from "@mui/material"

function Negative() {
  const reasonRef = useRef()
  const dispatch = useDispatch()
  const userServices = new UserServices(dispatch)
  const { type, data, loadings } = useSelector((state) => state.otherSlice)


  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog())
  }

  // Handle update
  const handleUpdate = async (e) => {
    e.preventDefault()
    const reason = reasonRef?.current?.value
    if (!reason?.trim()) {
      return dispatch(toastError("Reason is required"))
    }
    const deleteActions = {
      [DISABLE_USER_STATUS]: () =>
        userServices.disableUser({
          id: data?.memberId,
          reason: reason,
        })
    }

    const action = deleteActions[type]
    if (!action) return
    const { success } = await action()
    if (success) {
      setTimeout(() => {
        handleClose()
        dispatch(refresher())
      }, 100)
    }
  }

  return (
    <Paper component="form" onSubmit={handleUpdate}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >{titles?.[type] || null}
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        >
          <Icons.CancelSolid />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        <Box sx={{ display: "grid", placeContent: "center", mb: 2 }}>
          <Icon
            sx={{ fontSize: "60px", overflow: "visible", color: "error.main" }}
          >
            <Icons.AlertStroke />
          </Icon>
        </Box>

        <Stack spacing={1}>
          <Typography
            sx={{
              m: "0",
              color: "#333333",
              fontSize: "16px",
              fontWeight: "500",
              textAlign: "center",
              fontFamily: "Poppins",
            }}
          >{messages?.[type] || null}
          </Typography>
          {(data?.status === "rejected" || data?.status === false) && (
            <Box sx={{ label: { color: "other.color1" } }}>
              <InputFieldA
                name="reason"
                label="Reason *"
                type="textarea"
                ref={reasonRef}
                placeholder="Enter the reason"
              />
            </Box>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          type="submit"
          color="error"
          variant="contained"
          sx={{ minWidth: 120 }}
          endIcon={
            loadings?.update && (
              <CircularProgress size={20} thickness={5} color="paper" />
            )
          }
        >{btnText?.[type] || "Update"}
        </Button>
      </DialogActions>
    </Paper>
  )
}

export default Negative